module.exports = __webpack_public_path__ + "img/82.6a2f48ee.svg";